import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { HiddenKnowledge } from './components/HiddenKnowledge';
import { FractionationSection } from './components/FractionationSection';
import { ReframeSection } from './components/ReframeSection';
import { MicroTrance } from './components/MicroTrance';
import { FuturePacing } from './components/FuturePacing';
import { CTASection } from './components/CTASection';
import { ProductDetails } from './components/ProductDetails';
import { Navbar } from './components/Navbar';
import { MetaPixelTracker } from './components/MetaPixelTracker';
import { RecentPurchaseWidget } from './components/RecentPurchaseWidget';
import { LimitedTimeOfferWidget } from './components/LimitedTimeOfferWidget';
// Función para verificar si fbq está disponible
const isFbqAvailable = () => {
  return typeof window !== 'undefined' && typeof window.fbq !== 'undefined';
};
// Función segura para llamar a fbq
const safeFbq = (action: string, event: string, params?: any) => {
  if (isFbqAvailable()) {
    try {
      window.fbq(action, event, params);
      console.log(`Meta Pixel desde App: ${event} rastreado exitosamente`, params);
      return true;
    } catch (error) {
      console.error(`Error al rastrear ${event} desde App:`, error);
    }
  } else {
    console.warn(`No se pudo rastrear ${event} desde App: Meta Pixel no disponible`);
  }
  return false;
};
export function App() {
  useEffect(() => {
    // Verificar si el Pixel está cargado correctamente
    const checkPixel = () => {
      if (isFbqAvailable()) {
        // Rastrear eventos iniciales
        trackInitialEvents();
      } else {
        console.warn('Meta Pixel no disponible en App.tsx, reintentando en 1 segundo...');
        // Reintentar después de 1 segundo
        setTimeout(checkPixel, 1000);
      }
    };
    // Primera verificación después de 500ms para dar tiempo a que cargue
    setTimeout(checkPixel, 500);
    // Función para rastrear eventos iniciales
    const trackInitialEvents = () => {
      // Rastrear vista de página
      safeFbq('track', 'PageView');
      // Rastrear evento de lead
      safeFbq('track', 'Lead', {
        content_name: 'ImpulseX Landing Page',
        content_category: 'Activación Masculina',
        currency: 'CLP',
        value: 74990
      });
      // Rastrear evento de ViewContent para el producto
      safeFbq('track', 'ViewContent', {
        content_name: 'ImpulseX 30ML',
        content_category: 'Activación Masculina',
        content_ids: ['IMPULSEX30'],
        content_type: 'product',
        value: 74990,
        currency: 'CLP'
      });
      // Rastreo adicional para rendimiento de la landing page
      safeFbq('trackCustom', 'LandingPageLoad', {
        page_url: window.location.href,
        referrer: document.referrer,
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent
      });
    };
    // Rastrear salidas de la página
    const trackExit = () => {
      if (isFbqAvailable()) {
        safeFbq('trackCustom', 'PageExit', {
          timestamp: new Date().toISOString(),
          time_on_page: (new Date().getTime() - performance.timing.navigationStart) / 1000
        });
      }
    };
    // Agregar event listener para beforeunload
    window.addEventListener('beforeunload', trackExit);
    // Cleanup
    return () => {
      window.removeEventListener('beforeunload', trackExit);
    };
  }, []);
  return <div className="bg-black text-white min-h-screen" data-id="element-0">
      <MetaPixelTracker data-id="element-1" />
      <Navbar data-id="element-2" />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-0 pb-10" data-id="element-3">
        <Hero data-id="element-4" />
        <HiddenKnowledge data-id="element-5" />
        <FractionationSection data-id="element-6" />
        <ReframeSection data-id="element-7" />
        <MicroTrance data-id="element-8" />
        <FuturePacing data-id="element-9" />
        <CTASection data-id="element-10" />
        <ProductDetails data-id="element-11" />
      </main>
      <RecentPurchaseWidget data-id="element-12" />
      <LimitedTimeOfferWidget data-id="element-13" />
      {/* Pixel de verificación - asegura que haya un elemento visible para Meta */}
      <noscript data-id="element-14">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=773967181920012&ev=PageView&noscript=1" alt="Meta Pixel" data-id="element-15" />
      </noscript>
    </div>;
}